import { gql } from "config/graphql";
import { MutationResponse } from "config/types";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

type Acknowledgement = "InsuranceApplication" | "InsuranceMembership" | "FinanceMembership";

export interface ICreateAcknowledgementInput {
  recordId: string;
  recordType: "disclosure" | "document";
  contextId?: string;
  contextType?: Acknowledgement;
}

interface ICreateAcknowledgementData {
  createAcknowledgement: {
    acknowledgement: {
      id: string;
    };
  };
}

export const createAcknowledgementMutation: MutationResponse<
  ICreateAcknowledgementInput,
  ICreateAcknowledgementData
> = async (acknowledgement: ICreateAcknowledgementInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation createAcknowledgement($input: CreateAcknowledgementInput!) {
      createAcknowledgement(input: $input) {
        acknowledgement {
          id
        }
      }
    }
  `;

  const { data } = await client.mutate<ICreateAcknowledgementData>({
    variables: { input: acknowledgement },
    mutation,
  });
  return { data: assertDefined(data) };
};
